import { Subscription } from 'react-apollo'
import HeartbeatSubscriptionDocument from './heartbeatSubscription.gql'
import React from 'react'
import {
  HeartbeatSubscription as HeartbeatSubscriptionData,
  HeartbeatSubscriptionVariables
} from '#src/generated/graphql'

class HeartbeatSubscription extends Subscription<
  HeartbeatSubscriptionData,
  HeartbeatSubscriptionVariables
> {}

const Heartbeat: React.SFC = () => (
  <HeartbeatSubscription subscription={HeartbeatSubscriptionDocument}>
    {_props => {
      return null
    }}
  </HeartbeatSubscription>
)

export default Heartbeat
